import { DefaultPageState } from "../../../../common/models/StoreDefaultModel";

export type GateOutItemData = {};

export const initialGateOutPageState: DefaultPageState = {
  page: 1,
  itemsPerPage: 10,
  pagination: true,
  // order: { dataKey: "id", order: "desc" },
};
